import api from "@/api/apiConfig"
import {
    Post,
    Get,
    Put,
} from './base/baseAjax'
let getExpressManage = (param) => {
    return Post({
        url: api.express.getExpressManage,
        bodyParam: param
    })
}
let print = (param) => {
    return Post({
        url: api.express.print,
        bodyParam: param
    })
}

let sendExpress = (param) => {
    return Post({
        url: api.express.sendExpress,
        bodyParam: param
    })
}
let expressTrack = (param) => {
    return Post({
        url: api.express.expressTrack,
        bodyParam: param
    })
}
let exportExcel = (param) => {
    return Get({
        url: api.express.exportExcel,
        UrlParam: param
    })
}

let getExpressCompany = (param) => {
    return Get({
        url: api.express.getExpressCompany,
        PathParam: param
    })
}

//获取快递枚举，3：快递公司，4：发件公司，5：快递类型
let getSysDictionary = (type) => {
    return Get({
        url: api.express.getSysDictionary,
        PathParam: {type}
    })
}

// 获取快递白名单列表
let getExpressWhitelist = (param) => {
    return Post({
        url: api.express.getExpressWhitelist,
        bodyParam: param
    })
}

// 新增快递白名单
let addExpressWhitelist = (param) => {
    return Post({
        url: api.express.addExpressWhitelist,
        bodyParam: param
    })
}

//删除快递白名单
let deleteExpressWhitelist = (id) => {
    return Put({
        url: api.express.deleteExpressWhitelist,
        PathParam: id
    })
}

// 获取历史常用收件人列表
let getReceiverInfoList = (param) => {
    return Get({
        url: api.express.getReceiverInfoList,
        PathParam: param
    })
}

export default {
    getExpressManage,
    print,
    sendExpress,
    expressTrack,
    exportExcel,
    getExpressCompany,
    getSysDictionary,
    getExpressWhitelist,
    addExpressWhitelist,
    deleteExpressWhitelist,
    getReceiverInfoList,
}



// WEBPACK FOOTER //
// ./src/services/express.js